import { render, staticRenderFns } from "./KpIcon.vue?vue&type=template&id=1c57aaf1"
import script from "./KpIcon.vue?vue&type=script&lang=js"
export * from "./KpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports